import { mergeSx } from "@/utils/mergeSx";
import {
	Box,
	Divider,
	type SxProps,
	type Theme,
	type BoxProps,
} from "@mui/material";
import { useMemo } from "react";

interface FooterProps extends BoxProps {
	/** SxProps específico para a área que envolve o conteúdo (children) */
	contentSx?: SxProps<Theme>;
	/** Define se o divisor superior deve ser exibido. Padrão: true */
	showDivider?: boolean;
}

const containerBaseSx: SxProps<Theme> = {
	display: "flex",
	flexDirection: "column",
	gap: 2,
};

const contentBaseSx: SxProps<Theme> = {
	display: "flex",
	justifyContent: "flex-end",
	gap: 2,
};

export function Footer({
	children,
	sx,
	contentSx,
	showDivider = true,
	...rest
}: FooterProps) {
	const mergedContentSx = useMemo(
		() => mergeSx(contentBaseSx, contentSx),
		[contentSx],
	);

	return (
		<Box component='footer' sx={mergeSx(containerBaseSx, sx)} {...rest}>
			{showDivider && <Divider sx={{ width: "100%" }} />}

			<Box sx={mergedContentSx}>{children}</Box>
		</Box>
	);
}
